(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }


  /* =========================================================
     SMART HEADER
     Omlaag scrollen = verbergen
     Omhoog scrollen = direct tonen
     ========================================================= */

  function initMemoireSmartHeader() {
const headerSection = document.querySelector('.section-header');
const announcementSection = document.querySelector('.announcement-bar-section');

if (!headerSection || !announcementSection) {
  return;
}

    /*
      Geef de echte Shopify announcement-section
      automatisch onze eigen class.
    */
    if (announcementSection) {

    }

    if (document.body.dataset.memoireSmartHeader === 'true') {
      return;
    }

    document.body.dataset.memoireSmartHeader = 'true';

    let lastScrollY = window.scrollY;
    let ticking = false;

    function setHeaderHeights() {
  const announcementHeight = announcementSection.offsetHeight;
  const headerHeight = headerSection.offsetHeight;

  document.documentElement.style.setProperty(
    '--memoire-announcement-height',
    `${announcementHeight}px`
  );

  document.documentElement.style.setProperty(
    '--memoire-header-height',
    `${headerHeight}px`
  );
}

    function showHeader() {
      document.body.classList.remove('memoire-header-hidden');
      document.body.classList.add('memoire-header-visible');
    }

    function hideHeader() {
      document.body.classList.add('memoire-header-hidden');
      document.body.classList.remove('memoire-header-visible');

      headerSection.querySelectorAll('details[open]').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('is-closing');
      });
    }

    function updateHeader() {
      const currentScrollY = Math.max(window.scrollY, 0);

      if (currentScrollY <= 5) {
        showHeader();
      } else if (currentScrollY < lastScrollY) {
        showHeader();
      } else if (currentScrollY > lastScrollY) {
        hideHeader();
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    function onScroll() {
      if (ticking) {
        return;
      }

      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }

    setHeaderHeights();
    showHeader();

    window.addEventListener('scroll', onScroll, {
      passive: true
    });

    window.addEventListener('resize', setHeaderHeights);

    if ('ResizeObserver' in window) {
  const observer = new ResizeObserver(setHeaderHeights);

  observer.observe(announcementSection);
  observer.observe(headerSection);
}
  }


  /* =========================================================
     DESKTOP MEGA MENU HOVER
     ========================================================= */

  function initMemoireMegaMenuHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) {
      return;
    }

    const megaMenus = document.querySelectorAll('.mega-menu');

    megaMenus.forEach((menu) => {
      if (menu.dataset.memoireHoverInitialized === 'true') {
        return;
      }

      menu.dataset.memoireHoverInitialized = 'true';

      const summary = menu.querySelector('summary');

      if (!summary) {
        return;
      }

      let hoverCloseTimer = null;
      let animationCloseTimer = null;

      function cancelClose() {
        if (hoverCloseTimer) {
          window.clearTimeout(hoverCloseTimer);
          hoverCloseTimer = null;
        }

        if (animationCloseTimer) {
          window.clearTimeout(animationCloseTimer);
          animationCloseTimer = null;
        }

        menu.classList.remove('is-closing');
      }

      function closeMenuAnimated() {
        if (
          !menu.hasAttribute('open') ||
          menu.classList.contains('is-closing')
        ) {
          return;
        }

        menu.classList.add('is-closing');

        animationCloseTimer = window.setTimeout(() => {
          menu.removeAttribute('open');
          menu.classList.remove('is-closing');
          animationCloseTimer = null;
        }, 640);
      }

      function openMenu() {
        cancelClose();

        megaMenus.forEach((otherMenu) => {
          if (
            otherMenu !== menu &&
            otherMenu.hasAttribute('open')
          ) {
            otherMenu.removeAttribute('open');
            otherMenu.classList.remove('is-closing');
          }
        });

        if (!menu.hasAttribute('open')) {
          menu.setAttribute('open', '');
        }
      }

      menu.addEventListener('mouseenter', () => {
        openMenu();
      });

      menu.addEventListener('mouseleave', () => {
        if (hoverCloseTimer) {
          window.clearTimeout(hoverCloseTimer);
        }

        hoverCloseTimer = window.setTimeout(() => {
          closeMenuAnimated();
        }, 180);
      });

      summary.addEventListener('click', (event) => {
  const menuUrl = summary.dataset.menuUrl;

  if (!menuUrl || menuUrl === '#') {
    return;
  }

  event.preventDefault();
  window.location.href = menuUrl;
});
    });
  }


  function initMemoireHeaderFunctions() {
    initMemoireSmartHeader();
    initMemoireMegaMenuHover();
  }


  document.addEventListener(
    'DOMContentLoaded',
    initMemoireHeaderFunctions
  );

  if (document.readyState !== 'loading') {
    initMemoireHeaderFunctions();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener(
      'shopify:section:load',
      initMemoireHeaderFunctions
    );
  }
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );


  } catch(e) { console.error(e); }
})();
})();
